class VariantPicker extends HTMLElement {
    constructor() {
        super();
        this.handle = this.dataset.handle;
        this.id = this.dataset.productId;
        this.loadData(this.handle);
        this.selectors = this.querySelectorAll('.variant-selector');
        this.sectionId = this.dataset.sectionId;
        this.form = document.querySelector(`#product_form_${this.id}`)
        this.variant_id_select = this.form.querySelector(`#ProductSelect-${this.sectionId}`)
        this.quantity_input = this.form.querySelector(`.ProductQuantity-${this.sectionId}`)
        this.strings = window.theme.strings;
        this.cartBtn = this.form.querySelector(`#product-btn-${this.handle}`)
        this.priceContainer = document.querySelector(`#Product-${this.handle}-price`)

        this.product_carousel = $('.product-thumbnail-carousel').data('flickity');

        if(this.selectors) {
            this.loadEvents();
        }
    }
    async loadData() {
      const url = `${Shopify.routes.root}products/${this.handle}.js`;
  
      // Fetch product data and store it in the element's data property.
      const response = await fetch(url);

      const data = await response.json();

      this.data = data;
    }
    loadEvents() {
        const main_obj = this;
        this.selectors.forEach(selector => {
            selector.addEventListener('change', function() {
                let options = new Array();
                const current_index = this.dataset.index;
                const current_nodename = this.nodeName.toLowerCase();
                const current_value = this.value;
                
                main_obj.selectors.forEach(input => {
                    const it_nodename = input.nodeName.toLowerCase()

                    // Since there is two UI with same option example: Shade and Colour
                    // We need to make sure to make them share the same value if customer select either the two selections
                    if(it_nodename !== current_nodename && input.dataset.index === current_index) {
                      if(it_nodename === 'input') {
                        if(input.value === current_value) {
                          input.setAttribute('checked', '')
                        }else {
                          input.removeAttribute('checked')
                        }
                      }else {
                        input.value = current_value;
                      }
                    }
                  
                    // Return if same element index
                    if(input.nodeName.toLowerCase() !== current_nodename && input.dataset.index === current_index) return;

                    // Return if type radio and not check
                    if(input.type === 'radio' && !input.checked) return;

                    const included = options.find(opt => opt.index === this.dataset.index)

                    if(!included) {
                        options.push({
                            value: input.value,
                            index: this.dataset.index
                        })
                    }
                })
                const current_variant = main_obj.getCurrentSelectedVariant(options)
                main_obj.updateMasterVariant(current_variant);
            })
        })
    }
    getCurrentSelectedVariant(options) {
        // Find objects in options array that exist in variants array
        const current_variant = this.data.variants.filter(variant =>
            options.some(option =>
                variant.options[option.index] === option.value
            )
        )[0];
        
        if(current_variant) this.current_variant = current_variant;

        return current_variant;
    }
    updateMasterVariant(variant) {
        if(!variant) return;

        this.variant_id_select.value = variant.id;

        this.updateQuantity();
        this.updateBtn()
        this.updateSlideshow()
        this.updatePrice()
    }
    updateQuantity() {
        const selectedOption = this.variant_id_select.options[this.variant_id_select.selectedIndex];

        this.quantity_input.setAttribute('max', selectedOption.dataset.quantity)
    }
    updateBtn() {
        if(this.current_variant.available) {
            this.cartBtn.textContent = this.strings.addToCart
            this.cartBtn.removeAttribute('disabled');
        }else {
            this.cartBtn.textContent = this.strings.soldOut;
            this.cartBtn.setAttribute('disabled', '')
        }
    }
    updateSlideshow() {
        let index = this.current_variant.featured_media ? this.current_variant.featured_media.position - 1 : null;

        this.product_carousel.selectCell(index);
    }
    updatePrice() {
        const variant = this.current_variant;
        let price_html = ''
        if (variant.compare_at_price > variant.price && variant.compare_at_price != variant.price) {
            price_html = `
            <span class="text-sale">${theme.Currency.formatMoney(variant.price, theme.moneyFormat)}</span>
            <span class="ml-1 text-silver">${theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat)}</span>
          `
        } else {
            price_html =`
                <span>${theme.Currency.formatMoney(variant.price, theme.moneyFormat)}</span>
            `
        }

        $(this.priceContainer).empty();
        $(this.priceContainer).append(price_html);
    }
}

customElements.define('variant-picker', VariantPicker);

$(document).on('click', '.js-close-review', function(e) {

    e.preventDefault();

    var $this = $(this),
        btn = $('.jdgm-write-rev-link');

    $('.jdgm-form-wrapper').fadeOut();

    btn.removeClass('close-form-btn');
    btn.text('Write a review');
    btn.attr('aria-expanded', 'false');
})

$('.jdgm-write-rev-link').click(function() {
    var $this = $(this),
        $form = $('form.jdgm-form');


    if(!$form.find('.review-header-tpl').length > 0) {
    $form.prepend(reviewHeaderTpl);
    }
})

$('.js-product-mobile-accordion').click(function() {
    var $this = $(this),
        panel = $this.parent().find('.product-mobile-accordion-content'),
        icon = $this.find('.js-accordion-controller');

        panel.slideToggle('slow', function() {
        icon.toggleClass('is-collapsed');
        $this.parent().siblings().find('.product-mobile-accordion-content').slideUp();
        })
        $this.parent().siblings().find('.js-accordion-controller').removeClass('is-collapsed')
})

$('.tab-btns .tab').click(function() {
    var $this = $(this),
        index = $this.index(),
        content = $('.tabs-content .contents .content').eq(index);

        if(content.length > 0) {
        content.toggle().siblings().hide();
        $this.addClass('selected').siblings().removeClass('selected');
        }
})


$('.js-quantity-controller').click(function() {
    var $this = $(this),
        input = $this.parent().find('#js-select-quantity'),
        max = parseInt(input.attr('max')),
        oldValue = parseInt(input.val());

        if($this.hasClass('minus')) {
        var newVal = oldValue > 1 ? oldValue - 1 : oldValue;
        }else {
        var newVal = oldValue < max ? oldValue + 1 : oldValue;
        }

        if(newVal) {
        input.val(newVal)
        }
})